import { Component } from '@angular/core';

@Component({
  selector: 'app-data-vehicle',
  templateUrl: './data-vehicle.component.html',
  styleUrl: './data-vehicle.component.css',
})
export class DataVehicleComponent {}
